module.exports = __webpack_public_path__ + "img/exp.2a961a52.png";